import { AdditionalFieldsProps } from '@k3/core/src/lib/components/dialog/privateData/PrivateData'
import React from 'react'
import { OCTextInput } from '@k3/core'
import { OCTextInputProps } from '@k3/core/src/lib/components/OCTextInput'
import { Stack } from '@mui/material'

const textFieldProps: Partial<OCTextInputProps['TextFieldProps']> = {
  sx: {
    marginBottom: 0.5,
  },
  size: 'small',
  variant: 'standard',
}
export const CustomContactFields = ({
  action,
  handleChange,
  errors,
  register,
  getHelperText,
  privateData,
}: AdditionalFieldsProps) => {
  if (!action || !action.formular) return null
  const { name, sendCustomerEmail, phone, address, remark, company, taxID } =
    action.formular
  return (
    <>
      {name && (
        <OCTextInput
          data-cy={`name`}
          value={privateData.name}
          label={'Name*'}
          debounced
          required
          autoFocus
          TextFieldProps={{
            error: !!errors.name,
            helperText: getHelperText('name'),
            ...textFieldProps,
            ...register('name'),
          }}
          onChange={handleChange('name')}
        />
      )}

      {sendCustomerEmail && (
        <OCTextInput
          data-cy={`email`}
          value={privateData.email}
          label={'E-Mail*'}
          debounced
          autoComplete="email"
          required
          TextFieldProps={{
            type: 'email',
            error: !!errors.email,
            helperText: getHelperText('email'),
            ...textFieldProps,
            ...register('email'),
          }}
          onChange={handleChange('email')}
        />
      )}

      {phone && (
        <OCTextInput
          value={privateData.phone}
          data-cy={'Telefon*'}
          label={'Telefon*'}
          debounced
          required
          TextFieldProps={{
            error: !!errors.phone,
            helperText: getHelperText('phone'),
            ...textFieldProps,
            ...register('phone'),
          }}
          onChange={handleChange('phone')}
        />
      )}

      {address && (
        <>
          <OCTextInput
            value={privateData.address}
            data-cy={'Straße'}
            label={'Straße und Hausnummer*'}
            debounced
            required
            TextFieldProps={{
              error: !!errors.address,
              helperText: getHelperText('address'),
              ...textFieldProps,
              ...register('address'),
            }}
            onChange={handleChange('address')}
          />
          <Stack
            flexDirection={'row'}
            sx={{
              justifyContent: 'space-between',
              gap: 2,
              alignItems: 'top',
            }}
          >
            <OCTextInput
              value={privateData.zip}
              data-cy={'PLZ*'}
              label={'PLZ*'}
              debounced
              required
              TextFieldProps={{
                error: !!errors.zip,
                helperText: getHelperText('zip'),
                ...textFieldProps,
                ...register('zip'),
              }}
              onChange={handleChange('zip')}
            />
            <OCTextInput
              value={privateData.city}
              data-cy={'Stadt*'}
              label={'Stadt*'}
              debounced
              required
              fullWidth={true}
              TextFieldProps={{
                error: !!errors.city,
                helperText: getHelperText('city'),
                ...textFieldProps,
                ...register('city'),
              }}
              onChange={handleChange('city')}
            />
          </Stack>
        </>
      )}

      {remark && (
        <OCTextInput
          value={privateData.remark}
          data-cy={'Bemerkung'}
          label={'Bemerkung'}
          debounced
          multiline
          TextFieldProps={{
            error: !!errors.remark,
            helperText: getHelperText('remark'),
            ...textFieldProps,
            ...register('remark'),
          }}
          onChange={handleChange('remark')}
        />
      )}

      {company && (
        <OCTextInput
          value={privateData.company}
          data-cy={'Firma*'}
          label={'Firma*'}
          debounced
          required
          TextFieldProps={{
            error: !!errors.company,
            helperText: getHelperText('company'),
            ...textFieldProps,
            ...register('company'),
          }}
          onChange={handleChange('company')}
        />
      )}

      {taxID && (
        <OCTextInput
          value={privateData.taxID}
          data-cy={'UST'}
          label={'UST-ID*'}
          debounced
          required
          TextFieldProps={{
            error: !!errors.taxID,
            helperText: getHelperText('taxID'),
            ...textFieldProps,
            ...register('taxID'),
          }}
          onChange={handleChange('taxID')}
        />
      )}
    </>
  )
}
